export const translations = {
  en: {
    // Navigation
    about: 'About',
    skills: 'Skills',
    experience: 'Experience',
    work: 'Work',
    blog: 'Blog',
    contact: 'Contact',
    resume: 'Resume',

    // Hero Section
    greeting: 'Hi, my name is',
    name: '庄园',
    tagline: 'I create innovative mobile applications for the digital world.',
    description:
      'I am a Senior iOS Developer specializing in Web3, blockchain, decentralized applications, GameFi, and NFT technologies. With 10+ years of mobile development experience, I focus on building exceptional iOS applications and cross-platform solutions.',
    //company: 'Upstatement',
    cta: 'Check out my Application!',

    // About Section
    aboutTitle: 'About Me',
    aboutParagraph1:
      'Hello! My name is Zhuang Yuan, and I enjoy creating innovative mobile applications. My passion for iOS development began in 2013, and since then I have been dedicated to building high-quality mobile applications across various domains including Web3, blockchain, fintech, and social platforms.',
    aboutParagraph2:
      'Fast forward to today, I am now a Senior iOS Developer with expertise in Swift, Objective-C, SwiftUI, and Flutter. My current focus is on developing cutting-edge blockchain applications, NFT platforms, and decentralized social applications that serve millions of users worldwide.',
    aboutParagraph3:
      'In my spare time, I contribute to open-source projects, write technical blogs about iOS development and blockchain integration, and explore new technologies in the Web3 ecosystem.',
    aboutParagraph4: 'Here are a few technologies I\'ve been working with recently:',

    // Core Skills Section
    coreSkillsTitle: 'Core Skills',
    mobileDevelopmentTitle: 'Mobile Development',
    iosNativeDevelopment: 'iOS Native Development: Swift, Objective-C, SwiftUI',
    crossPlatformDevelopment: 'Cross-Platform Development: Flutter, React Native',
    realTimeCommunication: 'Real-Time Communication: WebSocket, Socket.IO',
    audioVideoProcessing: 'Audio & Video Processing: AVFoundation, WebRTC, Kurento',
    blockchainTechnologyTitle: 'Blockchain Technology',
    mainstreamBlockchains: 'Mainstream Blockchains: Bitcoin, Ethereum, TRON, Solana',
    smartContractDevelopment: 'Smart Contract Development & Integration',
    deFiProtocolIntegration: 'DeFi Protocol Integration',
    nftAndGameFiDevelopment: 'NFT and GameFi Application Development',
    technicalArchitectureTitle: 'Technical Architecture',
    mvvmMvpCleanArchitecture: 'MVVM, MVP, Clean Architecture',
    reactiveProgramming: 'Reactive Programming: RxSwift, Combine',
    dependencyInjection: 'Dependency Injection: Swinject',
    unitTesting: 'Unit Testing: XCTest, Quick/Nimble',

    // Jobs Section
    jobsTitle: 'Where I\'ve Worked',

    // Projects Section
    projectsTitle: 'Some Things I\'ve Built',
    featuredTitle: 'Featured Project',
    featuredSectionTitle: 'Some Things I\'ve Built',
    otherProjects: 'My Blog',
    viewMyBlog: 'view the MyBlog',
    updating: 'Updating...',
    showMore: 'Show More',
    showLess: 'Show Less',

    // Contact section
    contactTitle: 'Get In Touch',
    contactSubtitle: "What's Next?",
    contactDescription:
      "Although I'm not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!",
    sayHello: 'Say Hello',

    // Footer
    builtBy: '@2025 dayong',

    // MyBlog Page
    MyBlogTitle: 'MyBlog',
    MyBlogSubtitle: 'A big list of things I\'ve worked on',
    year: 'Year',
    project: 'Project',
    madeAt: 'Made at',
    builtWith: 'Built with',
    link: 'Link',

    // Pensieve (Blog)
    pensieveTitle: 'Pensieve',
    pensieveSubtitle: 'a collection of memories',
    allPosts: 'All Posts',

    // Application Page
    applicationTitle: 'Application List',
    applicationSubtitle:
      'The following applications are mainly used for learning and communication, including but not limited to open source, commercial use is not allowed, please read the repository open source license carefully',
    title: 'Title',
    category: 'Category',

    // 404 Page
    notFoundTitle: 'Page Not Found',
    notFoundDescription: 'The page you are looking for does not exist.',
    goHome: 'Go Home',

    // Resume Page
    resumeTitle: 'Resume',
    resumeLoading: 'Loading resume...',
    resumeLoadError: 'Failed to load',
    resumeLoadErrorDesc: 'Unable to load resume content',
    downloadResume: 'Download Resume',
    downloadPDF: 'Download PDF',
    downloadWord: 'Download Word',
    downloadPNG: 'Download PNG',
    downloadOptions: 'Download Options',
    buyMeACoffee: 'Buy Me a Coffee',

    // Resume Content
    resumeContact: 'Contact Information',
    resumePersonalInfo: 'Personal Information',
    resumeCoreSkills: 'Core Skills',
    resumeWorkExperience: 'Work Experience',
    resumeProjectExperience: 'Project Experience',
    resumeEducation: 'Education',
    resumePersonalTraits: 'Personal Traits',
    
    // SEO Meta
    seoTitle: 'Zhuang Yuan - Senior iOS Developer | Web3 & Blockchain Expert',
    seoDescription: 'Senior iOS Developer with 10+ years experience in Web3, blockchain, DeFi, GameFi, NFT technologies. Expert in Swift, SwiftUI, Flutter development serving millions of users worldwide.',
    seoKeywords: 'iOS Developer, Swift, SwiftUI, Flutter, Web3, Blockchain, DeFi, GameFi, NFT, Mobile Development, Cross-platform Development, Cryptocurrency, Fintech, Real-time Communication, Video Processing',
  },

  'zh-CN': {
    // Navigation
    about: '关于我',
    skills: '核心技能',
    experience: '工作经历',
    work: '作品集',
    blog: '博客',
    contact: '联系我',
    resume: '简历',

    // Hero Section
    greeting: '嗨，我的名字是',
    name: '庄园',
    tagline: '我为数字世界创造创新的移动应用',
    description:
      '我是一名资深 iOS 开发工程师，专注于 Web3、去中心化应用、交易所、出海工具 等前沿技术领域。拥有 10+ 年 iOS 移动端开发经验，致力于构建卓越的应用和跨平台解决方案。',
    //company: 'Upstatement',
    cta: '来玩玩我的应用吧！',

    // About Section
    aboutTitle: '关于我',
    aboutParagraph1:
      '你好！我的名字是庄园，我喜欢创造创新的移动应用。我对 iOS 开发的热情始于 2015 年，从那时起我一直致力于在 Web3、出海工具和社交平台等各个领域构建高质量的移动应用。',
    aboutParagraph2:
      '快进到今天，我已经是一名资深 iOS 开发工程师，精通 Swift、Objective-C、SwiftUI 和 Flutter。我目前的主要重点是开发交易所及去中心化钱包应用、社交应用，为全球数百万用户提供服务。',
    aboutParagraph3:
      '业余时间，我为开源项目做贡献，撰写关于 iOS 开发和区块链集成的技术博客，并探索 Web3 生态系统中的新技术。',
    aboutParagraph4: '以下是我的技术栈：',

    // Core Skills Section
    coreSkillsTitle: '核心技能',
    mobileDevelopmentTitle: '移动端开发',
    iosNativeDevelopment: 'iOS 原生开发：Swift、Objective-C、SwiftUI',
    crossPlatformDevelopment: '跨平台开发：Flutter、React Native',
    realTimeCommunication: '实时通信：WebSocket、Socket.IO',
    audioVideoProcessing: '音视频处理：AVFoundation、WebRTC、Kurento',
    blockchainTechnologyTitle: '区块链技术',
    mainstreamBlockchains: '主流区块链：Bitcoin、Ethereum、TRON、Solana',
    smartContractDevelopment: '智能合约开发与集成',
    deFiProtocolIntegration: 'DeFi 协议集成',
    nftAndGameFiDevelopment: 'NFT 和 GameFi 应用开发',
    technicalArchitectureTitle: '技术架构',
    mvvmMvpCleanArchitecture: 'MVVM、MVP、Clean Architecture',
    reactiveProgramming: '响应式编程：RxSwift、Combine',
    dependencyInjection: '依赖注入：Swinject',
    unitTesting: '单元测试：XCTest、Quick/Nimble',

    // Jobs Section
    jobsTitle: '我的工作经历',

    // Projects Section
    projectsTitle: '我开发的一些作品',
    featuredTitle: '精选项目',
    featuredSectionTitle: '项目经验',
    otherProjects: '我的博客',
    viewMyBlog: '查看档案库',
    updating: '更新中...',
    showMore: '显示更多',
    showLess: '显示更少',

    // Contact Section
    contactTitle: '接下来呢？',
    contactSubtitle: '与我联系',
    contactDescription:
      '虽然我目前没有在寻找新的机会，但我的收件箱永远是开放的。无论你有问题还是只是想打个招呼，我都会尽力回复你！',
    sayHello: '打声招呼',

    // Footer
    builtBy: '@2025 dayong',

    // MyBlog Page
    MyBlogTitle: '档案库',
    MyBlogSubtitle: '我参与过的项目大清单',
    year: '年份',
    project: '项目',
    madeAt: '制作于',
    builtWith: '使用技术',
    link: '链接',

    // Pensieve (Blog)
    pensieveTitle: '冥想盆',
    pensieveSubtitle: '记忆的收藏',
    allPosts: '所有文章',

    // Application Page
    applicationTitle: '应用列表',
    applicationSubtitle:
      '以下应用主要用于学习交流，包括不限于开源不允许商业用途，请仔细阅读仓库开源许可',
    title: '标题',
    category: '分类',

    // 404 Page
    notFoundTitle: '找不到页面',
    notFoundDescription: '您寻找的页面不存在。',
    goHome: '回到首页',

    // Resume Page
    resumeTitle: '简历',
    resumeLoading: '加载简历中...',
    resumeLoadError: '加载失败',
    resumeLoadErrorDesc: '无法加载简历内容',
    downloadResume: '下载简历',
    downloadPDF: '下载PDF',
    downloadWord: '下载Word',
    downloadPNG: '下载PNG',
    downloadOptions: '下载选项',
    buyMeACoffee: '请我喝咖啡',

    // Resume Content
    resumeContact: '联系方式',
    resumePersonalInfo: '个人简介',
    resumeCoreSkills: '核心技能',
    resumeWorkExperience: '工作经历',
    resumeProjectExperience: '项目经历',
    resumeEducation: '教育背景',
    resumePersonalTraits: '个人特点',
    
    // SEO Meta
    seoTitle: '庄园 - 资深iOS开发工程师 | Web3区块链专家',
    seoDescription: '资深iOS开发工程师，拥有10+年Web3、区块链、DeFi、GameFi、NFT技术经验。精通Swift、SwiftUI、Flutter开发，服务全球数百万用户。',
    seoKeywords: 'iOS开发, Swift, SwiftUI, Flutter, Web3, 区块链, DeFi, GameFi, NFT, 移动开发, 跨平台开发, 数字货币, 金融科技, 实时通信, 音视频处理, 移动应用开发, 区块链应用',
  },

  'zh-TW': {
    // Navigation
    about: '關於我',
    skills: '核心技能',
    experience: '工作經歷',
    work: '作品集',
    blog: '博客',
    contact: '聯絡我',
    resume: '履歷',

    // Hero Section
    greeting: '嗨，我的名字是',
    name: '莊園.',
    tagline: '我為數位世界創造創新的移動應用',
    description:
      '我是一名資深 iOS 開發工程師，專注於 Web3、區塊鏈、去中心化應用、GameFi、NFT 等前沿技術領域。擁有 10+ 年移動端開發經驗，致力於構建卓越的 iOS 應用和跨平台解決方案。',
    //company: 'Upstatement',
    cta: '查看我的應用！',

    // About Section
    aboutTitle: '關於我',
    aboutParagraph1:
      '你好！我的名字是莊園，我喜歡創造創新的移動應用。我對 iOS 開發的熱情始於 2013 年，從那時起我一直致力於在 Web3、區塊鏈、金融科技和社交平台等各個領域構建高質量的移動應用。',
    aboutParagraph2:
      '快進到今天，我已經是一名資深 iOS 開發工程師，精通 Swift、Objective-C、SwiftUI 和 Flutter。我目前的主要重點是開發前沿的區塊鏈應用、NFT 平台和去中心化社交應用，為全球數百萬用戶提供服務。',
    aboutParagraph3:
      '業餘時間，我為開源項目做貢獻，撰寫關於 iOS 開發和區塊鏈集成的技術博客，並探索 Web3 生態系統中的新技術。',
    aboutParagraph4: '以下是我最近使用的一些技術：',

    // Core Skills Section
    coreSkillsTitle: '核心技能',
    mobileDevelopmentTitle: '移動端開發',
    iosNativeDevelopment: 'iOS 原生開發：Swift、Objective-C、SwiftUI',
    crossPlatformDevelopment: '跨平台開發：Flutter、React Native',
    realTimeCommunication: '即時通信：WebSocket、Socket.IO',
    audioVideoProcessing: '音視頻處理：AVFoundation、WebRTC、Kurento',
    blockchainTechnologyTitle: '區塊鏈技術',
    mainstreamBlockchains: '主流區塊鏈：Bitcoin、Ethereum、TRON、Solana',
    smartContractDevelopment: '智能合約開發與集成',
    deFiProtocolIntegration: 'DeFi 協議集成',
    nftAndGameFiDevelopment: 'NFT 和 GameFi 應用開發',
    technicalArchitectureTitle: '技術架構',
    mvvmMvpCleanArchitecture: 'MVVM、MVP、Clean Architecture',
    reactiveProgramming: '響應式編程：RxSwift、Combine',
    dependencyInjection: '依賴注入：Swinject',
    unitTesting: '單元測試：XCTest、Quick/Nimble',

    // Jobs Section
    jobsTitle: '我的工作經歷',

    // Projects Section
    projectsTitle: '我建構的一些作品',
    featuredTitle: '精選專案',
    featuredSectionTitle: '專案經驗',
    otherProjects: '我的博客',
    viewMyBlog: '查看檔案庫',
    updating: '更新中...',
    showMore: '顯示更多',
    showLess: '顯示較少',

    // Contact Section
    contactTitle: '接下來呢？',
    contactSubtitle: '與我聯絡',
    contactDescription:
      '雖然我目前沒有在尋找新的機會，但我的收件匣永遠是開放的。無論你有問題還是只是想打個招呼，我都會盡力回覆你！',
    sayHello: '打聲招呼',

    // Footer
    builtBy: '@2025 dayong',

    // MyBlog Page
    MyBlogTitle: '檔案庫',
    MyBlogSubtitle: '我參與過的專案大清單',
    year: '年份',
    project: '專案',
    madeAt: '製作於',
    builtWith: '使用技術',
    link: '連結',

    // Pensieve (Blog)
    pensieveTitle: '冥想盆',
    pensieveSubtitle: '記憶的收藏',
    allPosts: '所有文章',

    // Application Page
    applicationTitle: '應用列表',
    applicationSubtitle:
      '以下應用主要用於學習交流，包括不限於開源不允許商業用途，請仔細閱讀倉庫開源許可',
    title: '標題',
    category: '分類',

    // 404 Page
    notFoundTitle: '找不到頁面',
    notFoundDescription: '您尋找的頁面不存在。',
    goHome: '回到首頁',

    // Resume Page
    resumeTitle: '履歷',
    resumeLoading: '載入履歷中...',
    resumeLoadError: '載入失敗',
    resumeLoadErrorDesc: '無法載入履歷內容',
    downloadResume: '下載履歷',
    downloadPDF: '下載PDF',
    downloadWord: '下載Word',
    downloadPNG: '下載PNG',
    downloadOptions: '下載選項',
    buyMeACoffee: '請我喝咖啡',

    // Resume Content
    resumeContact: '聯絡方式',
    resumePersonalInfo: '個人簡介',
    resumeCoreSkills: '核心技能',
    resumeWorkExperience: '工作經歷',
    resumeProjectExperience: '專案經歷',
    resumeEducation: '教育背景',
    resumePersonalTraits: '個人特點',
    
    // SEO Meta
    seoTitle: '莊園 - 資深iOS開發工程師 | Web3區塊鏈專家',
    seoDescription: '資深iOS開發工程師，擁有10+年Web3、區塊鏈、DeFi、GameFi、NFT技術經驗。精通Swift、SwiftUI、Flutter開發，服務全球數百萬用戶。',
    seoKeywords: 'iOS開發, Swift, SwiftUI, Flutter, Web3, 區塊鏈, DeFi, GameFi, NFT, 移動開發, 跨平台開發, 數字貨幣, 金融科技, 實時通信, 音視頻處理, 移動應用開發, 區塊鏈應用',
  },
};

export const defaultLanguage = 'zh-CN';
export const languages = ['en', 'zh-CN', 'zh-TW'];

export const getTranslation = (key, language = defaultLanguage) =>
  translations[language]?.[key] || translations[defaultLanguage]?.[key] || key;
